export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  price: number | 'custom';
  currency: string;
  mode: 'subscription' | 'payment' | 'contact';
  imageLimit?: number | null;
  features?: string[];
  isPopular?: boolean;
  disclaimer?: string;
  isEnterprise?: boolean;
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'prod_free_trial',
    priceId: 'price_free_trial',
    name: 'Free Trial',
    description: 'Try our generator with 4 free images',
    price: 0,
    currency: 'usd',
    mode: 'payment',
    imageLimit: 4,
    features: [
      '4 free images (one-time)',
      'Test our AI-powered generation',
      'See the quality before you buy',
      'No credit card required'
    ]
  },
  {
    id: 'prod_TKfCTWoaIeCpJT',
    priceId: 'price_1SNzsHJGYRa8WI9FykTvTg8z',
    name: 'Starter Plan',
    description: '30 images per month',
    price: 24,
    currency: 'usd',
    mode: 'subscription',
    imageLimit: 30,
    features: [
      '30 images per month',
      'AI-powered generation',
      'Commercial usage rights',
      'Download in high quality'
    ]
  },
  {
    id: 'prod_TME3TaI2k53tYT',
    priceId: 'price_1Sa0EcJGYRa8WI9F2RTXH8W4',
    name: 'Social Growth',
    description: '50 images per month',
    price: 39,
    currency: 'usd',
    mode: 'subscription',
    imageLimit: 50,
    isPopular: true,
    features: [
      '50 images per month',
      'AI-powered generation',
      'Commercial usage rights',
      'Download in high quality',
      'Priority support'
    ]
  },
  {
    id: 'prod_TME4leOz3Ctaab',
    priceId: 'price_1Sa0FFJGYRa8WI9FY5HnLXt6',
    name: 'Pro Plan',
    description: '100 images per month',
    price: 69,
    currency: 'usd',
    mode: 'subscription',
    imageLimit: 100,
    features: [
      '100 images per month',
      'AI-powered generation',
      'Commercial usage rights',
      'Download in high quality',
      'Priority support',
      'Advanced customization'
    ]
  },
  {
    id: 'prod_enterprise',
    priceId: 'price_enterprise',
    name: 'Enterprise Plan',
    description: 'Custom solutions for teams and organizations',
    price: 'custom',
    currency: 'usd',
    mode: 'contact',
    imageLimit: null,
    isEnterprise: true,
    features: [
      'Unlimited images for your entire team',
      'Multi-user accounts',
      'Custom branding and white-label options',
      'Dedicated success manager',
      'Priority support with SLA',
      'API access',
      'Custom integrations',
      'Volume discounts available',
      'Perfect for teams, brokerages, photographers, title companies, and marketing agencies'
    ]
  }
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.priceId === priceId);
};

export const formatPrice = (price: number | 'custom', currency: string = 'usd'): string => {
  if (price === 'custom') {
    return 'Custom Pricing';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(price);
};